/*! angular-neat-layout - v1.0.1 - 
 (c) Valentin Hervieu <valentin@hervi.eu> - 
 git+ssh://git@gitlab.com/ValentinH/angular-neat-layout.git - 
 2018-04-05 */
'use strict';

(function(angular) {
  NeatLayoutSidebar.$inject = ['$element', '$scope', '$document', '$timeout'];
  var module = angular.module('neatLayoutModule', []);

  module.directive('neatLayout', function() {
    return {
      restrict: 'E'
    };
  });

  module.directive('neatLayoutSidebar', function() {
    return {
      restrict: 'E',
      replace: true,
      transclude: true,
      scope: {
        position: '@',
        initialWidth: '=',
        minWidth: '=',
        maxWidth: '=',
        collapsed: '=?',
        collapsedText: '@'
      },
      templateUrl: 'angular-neat-layout-sidebar.html',
      controller: NeatLayoutSidebar,
      controllerAs: 'vm',
      bindToController: true
    };
  });

  function NeatLayoutSidebar($element, $scope, $document, $timeout) {
    var vm = this,
      jElement = $($element);

    vm.splitbarSelector = null;
    vm.startWidth = 0;
    vm.startX = 0;
    vm.currentX = 0;
    vm.resizingSidebar = 0;
    vm.isLeftPart = false;

    vm.activate = function() {
      vm.splitbarSelector = angular.element(jElement.find('.neat-splitbar'));
      vm.applySettings();
      vm.bindEvents();
    };

    vm.applySettings = function() {
      vm.isLeftPart = vm.position === 'left';
      if (vm.isLeftPart) {
        jElement.addClass('left-sidebar');
        vm.collapsedIcon = 'fa-angle-double-right';
        vm.notCollapsedIcon = 'fa-angle-double-left';
      }
      else {
        jElement.addClass('right-sidebar');
        vm.collapsedIcon = 'fa-angle-double-left';
        vm.notCollapsedIcon = 'fa-angle-double-right';
      }

      var style = {};
      if (vm.initialWidth != null)
        style.width = vm.initialWidth + 'px';
      if (vm.minWidth != null)
        style.minWidth = vm.minWidth + 'px';
      if (vm.maxWidth != null)
        style.maxWidth = vm.maxWidth + 'px';
      $element.css(style);
    };

    vm.bindEvents = function() {
      vm.splitbarSelector.on('mousedown', vm.onSplitbarMouseDown);
      vm.splitbarSelector.on('touchstart', vm.onSplitbarTouchstart);
    };

    vm.onSplitbarMouseDown = function(e) {
      e.preventDefault();
      vm.onSplitbarStart(e.pageX);
      $document.on('mousemove', vm.onSplitbarMouseMove);
      $document.on('mouseup', vm.onSplitbarUp);
    };

    vm.onSplitbarTouchstart = function(e) {
      e.preventDefault();
      var touches = e.touches || e.originalEvent.touches;
      vm.onSplitbarStart(touches[0].pageX);
      $document.on('touchmove', vm.onSplitbarTouchMove);
      $document.on('touchend', vm.onSplitbarUp);
    };

    vm.onSplitbarStart = function(x) {
      vm.startWidth = jElement[0].getBoundingClientRect().width;
      vm.startX = x;
      vm.currentX = vm.startX;
      vm.resizingSidebar = true;
      requestAnimationFrame(vm.sidebarUpdate);
    };

    vm.onSplitbarMouseMove = function(e) {
      e.preventDefault();
      vm.currentX = e.pageX;
    };

    vm.onSplitbarTouchMove = function(e) {
      e.preventDefault();
      var touches = e.touches || e.originalEvent.touches;
      vm.currentX = touches[0].pageX;
    };

    vm.onSplitbarUp = function() {
      vm.resizingSidebar = false;
      $document.off('mousemove', vm.onSplitbarMouseMove);
      $document.off('mouseup', vm.onSplitbarUp);
    };

    vm.sidebarUpdate = function() {
      if (!vm.resizingSidebar)
        return;
      requestAnimationFrame(vm.sidebarUpdate);

      var diff = vm.currentX - vm.startX;
      var newWidth = vm.isLeftPart ? vm.startWidth + diff : vm.startWidth - diff;

      if (vm.minWidth && newWidth < vm.minWidth)
        newWidth = vm.minWidth;

      if (vm.maxWidth && newWidth > vm.maxWidth)
        newWidth = vm.maxWidth;

      if (newWidth < 5) {
        $element.addClass('closed');
      }
      else {
        jElement.css('width', newWidth+'px');
        $element.removeClass('closed');
      }
    };

    vm.unbindEvents = function() {
      vm.splitbarSelector.off('mousedown', vm.onSplitbarMouseDown);
      vm.splitbarSelector.off('touchstart', vm.onSplitbarTouchstart);
    };

    $scope.$on('$destroy', function() {
      vm.unbindEvents();
    });

    $timeout(vm.activate);
  }

  module.run(['$templateCache', function($templateCache) {
  'use strict';

  $templateCache.put('angular-neat-layout-sidebar.html',
    "<div class=neat-layout-sidebar ng-class=\"{collapsed: vm.collapsed}\"><div ng-transclude ng-show=!vm.collapsed class=side-content></div><div ng-show=vm.collapsed class=collapsed-text>{{ vm.collapsedText }}</div><div class=neat-splitbar ng-hide=vm.collapsed></div><div class=neat-toggle ng-click=\"vm.collapsed=!vm.collapsed\"><i ng-show=vm.collapsed class=fa ng-class=vm.collapsedIcon aria-hidden=true></i> <i ng-show=!vm.collapsed class=fa ng-class=vm.notCollapsedIcon aria-hidden=true></i></div></div>"
  );

}]);
})(window.angular);



// WEBPACK FOOTER //
// ./app/lib/angular-neat-panel/angular-neat-layout.js